import styles from './Loader.scss'
import loaderAI from '../../assets/loader.gif'
import ReactDOM from 'react-dom'

const LoaderAI = () => {
  return ReactDOM.createPortal (
    <div className={styles.wrapper}>
      <div className={styles.loader}>
        <img src={loaderAI} alt="loading..." />
      </div>
    </div>,
    document.getElementById("loader")
  )
}

export default LoaderAI
